import { render, staticRenderFns } from "./newOrderModal.vue?vue&type=template&id=1a82e97d&scoped=true&"
import script from "./newOrderModal.vue?vue&type=script&lang=js&"
export * from "./newOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./newOrderModal.vue?vue&type=style&index=0&id=1a82e97d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a82e97d",
  null
  
)

export default component.exports